import React, { createContext, useContext, useState } from 'react';

export const CURRENCIES = {
  GBP: 'GBP',
  USD: 'USD',
};

export const REGIONS = {
  UK: 'UK',
  US: 'US',
};

const REGION_CURRENCY_MAP = {
  [REGIONS.UK]: CURRENCIES.GBP,
  [REGIONS.US]: CURRENCIES.USD,
};

const CurrencyContext = createContext();

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrencyState] = useState(CURRENCIES.GBP);
  const [region, setRegionState] = useState(REGIONS.UK);

  const setCurrency = (newCurrency) => {
    if (Object.values(CURRENCIES).includes(newCurrency)) {
      setCurrencyState(newCurrency);
    }
  };

  const setRegion = (newRegion) => {
    if (Object.values(REGIONS).includes(newRegion)) {
      setRegionState(newRegion);
      const mappedCurrency = REGION_CURRENCY_MAP[newRegion];
      if (mappedCurrency) {
        setCurrencyState(mappedCurrency);
      }
    }
  };

  const value = {
    currency,
    setCurrency,
    region,
    setRegion,
  };

  return (
    <CurrencyContext.Provider value={value}>
      {children}
    </CurrencyContext.Provider>
  );
};

export const useCurrency = () => {
  const context = useContext(CurrencyContext);
  if (context === undefined) {
    throw new Error('useCurrency must be used within a CurrencyProvider');
  }
  return context;
};